import moment from "moment";

export const formatAndSplitDate = (date) => {
  const formattedDate = moment(date)?.format("YYYY-MM-DD");
  const year = formattedDate?.split("-")?.[0];
  const month = formattedDate?.split("-")?.[1];
  const day = formattedDate?.split("-")?.[2];
  return { formattedDate, year, month, day };
};
